import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/login.vue';
import Main from '@/views/main.vue';
import Home from '@/views/home.vue';

import goodsRouter from '@/router/goods.js';
import memberRouter from '@/router/member.js';
import commonRouter from '@/router/common.js';
import assetRouter from '@/router/asset.js';
import orderRouter from '@/router/order.js';
import common from '@/script/common.js';
import bankRouter from '@/router/bank.js';
import authorityRouter from '@/router/authority.js';
import activeRouter from '@/router/active.js';
import couponRouter from '@/router/coupon.js';
import discountRouter from '@/router/discount.js';
import repositoryRouter from '@/router/repository.js';

Vue.use(VueRouter)
const routes = [{
    path: '/',
    redirect: '/home'
},
    {
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '/main',
        component: Main,
        name: 'main',
        children: [{
            path: '/home',
            component: Home,
            name: 'home'
        },
            ...goodsRouter,
            ...memberRouter,
            ...commonRouter,
            ...assetRouter,
            ...orderRouter,
            ...bankRouter,
            ...authorityRouter,
            ...activeRouter,
            ...couponRouter,
            ...discountRouter,
            ...repositoryRouter,
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    var token = common.cacheToken();
    if (token) {
        next();
    } else {
        if (to.name == 'login') {
            next();
        } else {
            next({
                name: 'login'
            });
            return false;
        }
    }
});
export default router
